import React from 'react';
import { ThemeProvider } from 'emotion-theming';
import { Global } from '@emotion/core';
import { theme as defaultTheme } from '../config';
import globalStyle from './globalStyles';
import { Props, APIProps } from './Provider.types';

const TP: React.FC<APIProps> = ({ children, useFonts }: Props & APIProps) => {
  const theme = { ...defaultTheme };

  if (typeof useFonts === 'function') {
    const fonts = useFonts({
      ...theme['fonts'],
      baseFontSize: theme.sizes.font.base,
      lineHeight: theme.lineHeight.base,
    });

    theme.fonts = fonts;
    theme.sizes.font.base = fonts.baseFontSize;
    theme.lineHeight.base = fonts.lineHeight;
  }

  return (
    <ThemeProvider theme={theme}>
      <Global styles={globalStyle} />
      {children}
    </ThemeProvider>
  );
};

export default TP;
